import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function ThemedSativaFlowerTypeIndicator(props) {
  const config = useThemeConfig();
  const ThemedSativaFlowerTypeIndicator = config.components.SativaTypeIndicator;

  return <ThemedSativaFlowerTypeIndicator {...props} />;
}
